import {get} from '@/lib/axios';

const app = {
  async get_settings() {
    return get('/settings');
  },
};

export {app as default};
